__turbopack_context__.v({
  "fadeInUp": "A9g9Uq_fadeInUp",
  "headerAnimation": "A9g9Uq_headerAnimation",
  "itemAnimation": "A9g9Uq_itemAnimation",
  "sectionAnimation": "A9g9Uq_sectionAnimation",
});
